export const RESOURCE_LIMIT_EXCEEDED_MESSAGE = 'Resource limit exceeded.';
